/// <reference types="jquery" />
import '../src/polyfills.js'

declare global {
  interface Window {
    inviteUserFormSetup: () => void
    arrayIncludes: (array: any[], element: any) => boolean
    cloneUserRow: (email: string) => void
    removeElement: (array: any[], element: any) => void
    emailList: string[]
    addAriaLabelToChosenDropdowns?: () => void
    setupScreenReaderForChosen?: (id: string) => void
    setModalIDToStorage?: (modalId: string, focusClass: string) => void
  }

  interface JQuery {
    foundation(method: string, action: string): JQuery
  }
}

const emailList: string[] = []
window.emailList = emailList

function cloneUserRow(email: string) {
  $('.js-email').val('')
  $('.js-add-email-button').prop('disabled', true)
  $('.js-invite-form-button-wrapper').removeClass('hide')
  const userRow = $('.js-user-row').first()
  const clonedUserRow = userRow.clone(true)
  const showUserRow = clonedUserRow.removeClass('hide')

  // set staff as default option
  showUserRow.children('.js-user-role-wrapper').children('select').val('staff')
  // set a unique id for each cloned select element
  const selectEle = showUserRow
    .children('.js-user-role-wrapper')
    .children('select')[0] as HTMLSelectElement
  if (selectEle) {
    selectEle.id = 'user__role_' + Math.random().toString(36).substring(2, 11)
  }
  const filteredEmail = email.split('@')[0]
  // set unique attribute for screen reader select and label
  const departmentSelectionWrapper = showUserRow.children(
    '.js-department-selection-wrapper'
  )
  departmentSelectionWrapper
    .find("label[for='screen-reader-users__department_ids']")
    .attr('for', 'screen-reader-users__department_ids_' + filteredEmail)
  departmentSelectionWrapper
    .find('#screen-reader-users__department_ids')
    .attr('id', 'screen-reader-users__department_ids_' + filteredEmail)
  // set unique id for chosen select
  departmentSelectionWrapper
    .find('#users__department_ids')
    .attr('id', 'users__department_ids_' + filteredEmail)

  // Adds email label above role and department selection
  showUserRow.children('.js-user-email-text').html(email)
  showUserRow
    .children('.js-user-email-input')
    .children('.email-input')
    .val(email)

  $('.js-email-field').append(showUserRow)

  // Show message text area
  $('.js-message-row-wrapper').show()
  const departmentSelect = showUserRow.find('select[name*="department"]')
  if (
    departmentSelect.length > 0 &&
    typeof (departmentSelect as any).chosen === 'function'
  ) {
    ;(departmentSelect as any).chosen({
      width: '100%',
      search_contains: true
    })
  }

  // Add margin and padding
  $('.js-add-form-margin .js-email-field .js-user-row:nth-child(1)')
    .removeClass('shim3-top')
    .addClass('shim2-top')
  $('.js-add-form-margin').addClass('padhalf-top shim2-top')
  $('.reveal-modal').addClass('modal-padding pad0-left pad0-right')
  $('.chosen-container').addClass('small-shim1-top').trigger('chosen:updated')

  if (typeof window.addAriaLabelToChosenDropdowns === 'function') {
    window.addAriaLabelToChosenDropdowns()
  }

  // Add a styled wrapper to user role select box
  $('select').addClass('f--input-wrapper')

  if (typeof window.setupScreenReaderForChosen === 'function') {
    window.setupScreenReaderForChosen('users__department_ids_' + filteredEmail)
  }
}

function inviteUserFormSetup() {
  $('.reveal-modal').on('click', '.js-add-email-button', function () {
    $('.js-warning').addClass('hide')
    const email = $('.js-invite-email').val() as string
    $.ajax({
      data: {
        email
      },
      type: 'get',
      url: '/account_lookup'
    })
  })

  $('.reveal-modal').on('keyup', '.js-email', function () {
    const emailField = $('.js-email').val() as string
    const atLeastOneEmail = emailField.length > 0
    $('.js-add-email-button').prop('disabled', !atLeastOneEmail)
  })

  $('.js-user-row').on('click', '.js-remove-user-row', function () {
    const userRow = $(this).closest('.js-user-row')
    const closestEmail = userRow
      .find('.js-user-email-input > input')
      .val() as string
    removeElement(emailList, closestEmail)
    if (emailList.length === 0) {
      $('.js-add-form-margin').removeClass('padhalf-top shim2-top')
      $('.js-message-row-wrapper').hide()
      $('.js-invite-form-button-wrapper').addClass('hide')
    }
    userRow.remove()
  })

  $('.reveal-modal').on('click', '#cancel-invite-form', function () {
    ;($('#invite-modal') as any).foundation('reveal', 'close')
  })

  $('.reveal-modal').on('click', '#js-send-invite-button', function () {
    if (typeof window.setModalIDToStorage === 'function') {
      window.setModalIDToStorage('#invite-modal', '.js-invite-modal-tab-focus')
    }
    const target = $('#invite-modal')
    // Note: Spinner functionality would need to be imported separately
    // For now, just show a loading state
    target.addClass('loading')
  })
}

function removeElement(array: any[], element: any) {
  array.forEach(function (i) {
    if (i === element) {
      array.splice(array.indexOf(i), 1)
    }
  })
}

function arrayIncludes(array: any[], element: any) {
  return $.inArray(element, array) >= 0
}

// Make functions available globally
window.inviteUserFormSetup = inviteUserFormSetup
window.arrayIncludes = arrayIncludes
window.cloneUserRow = cloneUserRow
window.removeElement = removeElement
